import React, { useState } from "react";
import { HiArrowRight, HiArrowLeft, HiCalendar } from "react-icons/hi2";
import Button from "../../common/Button/Button";
import SuccessModal from "../../common/SuccessModal/SuccessModal";
import "./Step4.scss";

const Step4 = ({ onNext, onBack, initialData }) => {
    const [formData, setFormData] = useState({
        buildingConditions: initialData?.buildingConditions || [],
        conditionsOther: initialData?.conditionsOther || "",
        accessRequirements: initialData?.accessRequirements || "",
        scanningDate: initialData?.scanningDate || "",
        additionalComments: initialData?.additionalComments || "",
    });

    const [errors, setErrors] = useState({});
    const [showSuccessModal, setShowSuccessModal] = useState(false);

    const buildingConditionsOptions = [
        "Ocupado",
        "Desocupado",
        "No en uso (cerrado/abandonado/vacío)",
        "Mobiliario presente",
        "Maquinaria presente",
        "Energía completa",
        "Sin energía",
        "Construcción en progreso",
        "Demolición en progreso",
        "Otro",
    ];

    const handleCheckboxChange = (value) => {
        setFormData((prev) => {
            const currentArray = prev.buildingConditions;
            const newArray = currentArray.includes(value)
                ? currentArray.filter((item) => item !== value)
                : [...currentArray, value];
            return { ...prev, buildingConditions: newArray };
        });

        if (errors.buildingConditions) {
            setErrors((prev) => ({ ...prev, buildingConditions: null }));
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        if (errors[name]) {
            setErrors((prev) => ({ ...prev, [name]: null }));
        }
    };

    const validateForm = () => {
        const newErrors = {};

        if (formData.buildingConditions.length === 0) {
            newErrors.buildingConditions = "Selecciona al menos una condición";
        }

        if (
            formData.buildingConditions.includes("Otro") &&
            !formData.conditionsOther.trim()
        ) {
            newErrors.conditionsOther = "Especifica la condición";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (validateForm()) {
            setShowSuccessModal(true);
            // onNext(formData);
        } else {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    };

    const handleCloseModal = () => {
        setShowSuccessModal(false);
        onNext(formData);
    };

    const isFormValid = () => {
        return (
            formData.buildingConditions.length > 0 &&
            (!formData.buildingConditions.includes("Otro") ||
                formData.conditionsOther.trim())
        );
    };

    return (
        <>
            <div className="step4">
                <div className="step4__container">
                    <div className="step4__header">
                        <h2 className="step4__title">Accesibilidad</h2>
                        <p className="step4__subtitle">
                            Condiciones del edificio y requisitos de acceso
                        </p>
                    </div>

                    <form className="step4__form" onSubmit={handleSubmit}>
                        <div className="form-card">
                            <div className="form-card__header">
                                <h3 className="form-card__title">
                                    Condiciones del Edificio *
                                </h3>
                                <span className="form-card__count">
                                    {formData.buildingConditions.length}{" "}
                                    seleccionada
                                    {formData.buildingConditions.length !== 1
                                        ? "s"
                                        : ""}
                                </span>
                            </div>

                            {errors.buildingConditions && (
                                <p className="error-message">
                                    {errors.buildingConditions}
                                </p>
                            )}

                            <div className="checkbox-grid">
                                {buildingConditionsOptions.map((condition) => (
                                    <label
                                        key={condition}
                                        className="checkbox-card"
                                    >
                                        <input
                                            type="checkbox"
                                            checked={formData.buildingConditions.includes(
                                                condition
                                            )}
                                            onChange={() =>
                                                handleCheckboxChange(condition)
                                            }
                                        />
                                        <span className="checkbox-card__box"></span>
                                        <span className="checkbox-card__label">
                                            {condition}
                                        </span>
                                    </label>
                                ))}
                            </div>

                            {formData.buildingConditions.includes("Otro") && (
                                <div className="other-input-card">
                                    <input
                                        type="text"
                                        name="conditionsOther"
                                        value={formData.conditionsOther}
                                        onChange={handleInputChange}
                                        placeholder="Especifica otras condiciones..."
                                        className={
                                            errors.conditionsOther
                                                ? "error"
                                                : ""
                                        }
                                    />
                                    {errors.conditionsOther && (
                                        <span className="error-text">
                                            {errors.conditionsOther}
                                        </span>
                                    )}
                                </div>
                            )}
                        </div>

                        <div className="form-card">
                            <div className="form-card__header">
                                <h3 className="form-card__title">
                                    Requisitos de Acceso y Restricciones del
                                    Sitio
                                </h3>
                                <span className="form-card__badge">
                                    Opcional
                                </span>
                            </div>

                            <textarea
                                name="accessRequirements"
                                value={formData.accessRequirements}
                                onChange={handleInputChange}
                                placeholder="Ejemplo: TBC (To Be Confirmed), restricciones de horario, permisos especiales, etc."
                                rows="5"
                                className="form-textarea"
                            />
                        </div>

                        <div className="form-card">
                            <div className="form-card__header">
                                <h3 className="form-card__title">
                                    Fecha Tentativa de Escaneo
                                </h3>
                                <span className="form-card__badge">
                                    Opcional
                                </span>
                            </div>

                            <p className="form-card__description">
                                Selecciona un día, semana o mes si la fecha de
                                escaneo no está confirmada aún
                            </p>

                            <div
                                className="date-input-wrapper"
                                onClick={() =>
                                    document
                                        .querySelector(
                                            'input[name="scanningDate"]'
                                        )
                                        .showPicker()
                                }
                            >
                                <HiCalendar className="date-input-icon" />
                                <input
                                    type="date"
                                    name="scanningDate"
                                    value={formData.scanningDate}
                                    onChange={handleInputChange}
                                    className="date-input"
                                />
                            </div>
                        </div>

                        <div className="form-card">
                            <div className="form-card__header">
                                <h3 className="form-card__title">
                                    Comentarios Adicionales
                                </h3>
                                <span className="form-card__badge">
                                    Opcional
                                </span>
                            </div>

                            <textarea
                                name="additionalComments"
                                value={formData.additionalComments}
                                onChange={handleInputChange}
                                placeholder="Añade cualquier información adicional que consideres necesaria para describir el alcance del proyecto"
                                rows="6"
                                className="form-textarea"
                            />
                        </div>

                        <div className="form-actions">
                            <Button
                                variant="outline"
                                icon={<HiArrowLeft />}
                                animationType="pop"
                                onClick={(e) => {
                                    e.preventDefault();
                                    onBack();
                                }}
                            >
                                Volver
                            </Button>

                            <Button
                                variant="filled"
                                icon={<HiArrowRight />}
                                animationType="pop"
                                disabled={!isFormValid()}
                            >
                                Enviar Proyecto
                            </Button>
                        </div>
                    </form>
                </div>
            </div>

            <SuccessModal
                isOpen={showSuccessModal}
                onClose={handleCloseModal}
            />
        </>
    );
};

export default Step4;
